import Dexie from 'dexie';

export const db = new Dexie('versatils');
// db.version(1).stores({
//   fichajes: '++id, lat, long, fecha, tipo, subido', //Tipo: 1-0 entrada-salida -- Subido: 1-0 si-no
// });

db.version(1).stores({
  fichajes: '++id, lat_ing, lng_ing, lat_sal, lng_sal, fecha_ing, fecha_sal, subido', //Subido: 1-0 si-no
});